import { Button } from "./Button"

interface LoadMoreButtonProps {
  hasMore: boolean
  isLoading: boolean
  onClick: () => void
}

export function LoadMoreButton({ hasMore, isLoading, onClick }: LoadMoreButtonProps) {
  if (!hasMore) return null

  return (
    <div className="flex justify-center mt-6">
      <Button
        variant="outline"
        onClick={onClick}
        disabled={isLoading}
      >
        {isLoading ? (
          <span className="flex items-center gap-2">
            <div className="h-4 w-4 animate-spin rounded-full border-2 border-gray-500 border-t-transparent" />
            Loading...
          </span>
        ) : (
          "Load More"
        )}
      </Button>
    </div>
  )
}
